import {
  Directive,
  ViewContainerRef,
  Renderer,
  Input,
  AfterViewInit
} from '@angular/core';


export class AppendViewContainerRefDirective implements AfterViewInit {

   public viewContainerRefToAppend: ViewContainerRef;

  constructor(private viewRef: ViewContainerRef, private renderer: Renderer) {
  }

  public ngAfterViewInit() {
    this.renderer.projectNodes(
      this.viewRef.element.nativeElement,
      [this.viewContainerRefToAppend.element.nativeElement]
    );
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[append-view-container-ref]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'viewContainerRefToAppend': [{ type: Input, args: ['append-view-container-ref', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
